(function () {
  // ---------------------------------------------------------------------------
  // 0. CONFIG – ADD YOUR ALGOLIA DETAILS HERE
  // ---------------------------------------------------------------------------
var ALGOLIA_APP_ID = "S3IULSU7MS";
var ALGOLIA_SEARCH_KEY = "3f07447532f1f6d8a19e4415b38f49c5";
var DEFAULT_INDEX_NAME = "shopify_products";

  // ---------------------------------------------------------------------------
  // 1. Guards & plugin setup
  // ---------------------------------------------------------------------------
  if (!window.Vue || !window.algoliasearch || !window.VueInstantSearch) {
    console.error("[book-components] Missing one of Vue, algoliasearch, VueInstantSearch", {
      Vue: !!window.Vue,
      algoliasearch: !!window.algoliasearch,
      VueInstantSearch: !!window.VueInstantSearch
    });
    return;
  }

  Vue.use(window.VueInstantSearch);

  // Single Algolia client reused by everything
  var searchClient = algoliasearch(ALGOLIA_APP_ID, ALGOLIA_SEARCH_KEY);

  // ---------------------------------------------------------------------------
  // 2. Helper functions to read attributes from DOM
  // ---------------------------------------------------------------------------
  function boolAttr(el, name, defaultVal) {
    // support both name="true" and :name="true"
    var v = el.getAttribute(name);
    if (v === null) v = el.getAttribute(":" + name);
    if (v === null) return defaultVal;

    v = ("" + v).trim();
    if (v === "" || v === "true" || v === "1") return true;
    if (v === "false" || v === "0") return false;
    return defaultVal;
  }

  function numAttr(el, name, defaultVal) {
    // support both name="3" and :name="3"
    var v = el.getAttribute(name);
    if (v === null) v = el.getAttribute(":" + name);
    if (v === null || v === "") return defaultVal;
    var n = Number(v);
    return isNaN(n) ? defaultVal : n;
  }

  // Parse a Vue-style :search-query string like:
  // { query : ['ID1','ID2'], attributes : ['product_id'] }
  function parseSearchQueryAttr(str) {
    if (!str) return null;

    var tokens = [];
    var re = /'([^']+)'/g;
    var m;
    while ((m = re.exec(str))) {
      tokens.push(m[1]);
    }
    if (!tokens.length) return null;

    // Assume last token is attribute name (e.g. 'product_id')
    var attrName = tokens[tokens.length - 1];
    var ids = tokens.slice(0, -1);

    return {
      query: ids,
      attributes: [attrName]
    };
  }

  // ---------------------------------------------------------------------------
  // 3. SearchWrapper (used by shopify-book-type & experts-by-ids)
  // ---------------------------------------------------------------------------
  var SearchWrapper = {
    name: "SearchWrapper",
    template:
      '<ais-instant-search ' +
        'v-if="ready" ' +
        ':search-client="$root.algolia.searchClient" ' +
        ':index-name="indexToUse" ' +
        ':class-names="{ \'ais-InstantSearch\': \'ais-index\' }"' +
      '>' +
        '<ais-configure ' +
          ':hits-per-page.camel="hitsPerPage" ' +
          'v-bind="queryParameters" ' +
        '/>' +
        '<ais-hits :class-names="{ \'ais-Hits\': \'ais-results\' }">' +
          '<template slot-scope="{ items }">' +
            '<slot v-bind:items="items"></slot>' +
          '</template>' +
        '</ais-hits>' +
        '<ais-pagination ' +
          'v-if="pagination" ' +
          ':class-names="{ \'ais-Pagination-list\': \'pagination\' }"' +
        '></ais-pagination>' +
      '</ais-instant-search>',
    props: {
      queryParameters: {
        type: Object,
        default: function () {
          return {};
        }
      },
      hitsPerPage: {
        type: Number,
        default: 25
      },
      index: {
        type: String,
        default: DEFAULT_INDEX_NAME
      },
      pagination: {
        type: Boolean,
        default: false
      }
    },
    computed: {
      ready: function () {
        return !!this.$root.algoliaReady;
      },
      indexToUse: function () {
        return this.index || DEFAULT_INDEX_NAME;
      }
    }
  };

  // ---------------------------------------------------------------------------
  // 4. <shopify-book-type> (your original component)
  // ---------------------------------------------------------------------------
var ShopifyBookType = {
    name: "ShopifyBookType",
    components: { "search-wrapper": SearchWrapper },
    props: ["primary", "product_type", "verkid", "algo_index", "dev_env", "headline"],
    template:
        '<div class="product-variations-wrapper"><span class="primary-variant--wrapper">' +
          "<search-wrapper " +
          'v-slot:default="{ items }" ' +
          ':query-parameters="queryP" ' +
          ':hits-per-page="24" ' +
          ':index="algo_index || defaultIndex"' +
          ">" +
            "<div " +
            'class="variants-dd" ' +
            'v-if="items.length && headline" ' +
            'v-html="headline"' +
            "></div>" +
            '<div v-for="result in items" :key="result.objectID">' +
              '<div v-if="result.primary">' +
                "<div v-if=\"product_type === 'print'\">" +
                  '<div class="tab--wrapper flex-wrapper">' +
                    "<div " +
                    'class="tab tab--1 active" ' +
                    'data-tab="1" ' +
                    'data-type="tryckt-upplaga"' +
                    ">" +
                      '<div class="tab--headline">Tryckt upplaga</div>' +
                      "</div>" +
                      "<a " +
                      ':href="result.handle | addUrl(dev_env)" ' +
                      'class="button button-blue button-secondary tab tab--2" ' +
                      'data-tab="2" ' +
                      'data-type="digital-upplaga"' +
                      ">" +
                      '<div class="tab--headline">Digital upplaga</div>' +
                      "</a>" +
                      "</div>" +
                      "</div>" +
                      "<div v-else>" +
                      '<div class="tab--wrapper flex-wrapper">' +
                      "<a " +
                      ':href="result.handle | addUrl(dev_env)" ' +
                      'class="button button-blue button-secondary tab tab--1" ' +
                      'data-tab="1" ' +
                      'data-type="tryckt-upplaga"' +
                      ">" +
                      '<div class="tab--headline">Tryckt upplaga</div>' +
                      "</a>" +
                      "<div " +
                      'class="tab tab--2 active" ' +
                      'data-tab="2" ' +
                      'data-type="digital-upplaga"' +
                      ">" +
                      '<div class="tab--headline">Digital upplaga</div>' +
                    "</div>" +
                  "</div>" +
                "</div>" +
              "</div>" +
            "</div>" +
          "</search-wrapper>" +
        "</span></div>",
    computed: {
        queryP: function () {
            return { filters: "NOT primary:" + this.primary + " AND verkid:" + this.verkid };
        },
        defaultIndex: function () {
            return DEFAULT_INDEX_NAME;
        },
    },
    filters: {
        addUrl: function (value, devenv) {
            if (!value) return "";
            value = value.toString();
            if (devenv) {
                return "https://devgomoon.myshopify.com/products/" + value;
            } else {
                return "https://shop.nj.se/products/" + value;
            }
        },
    },
};

  // ---------------------------------------------------------------------------
  // 5. SearchGrid (from SearchGrid.vue)
  // ---------------------------------------------------------------------------
  var SearchGrid = {
    name: "SearchGrid",
    template:
      '<div class="search-grid search-container" v-if="ready">' +
        '<ais-instant-search ref="instantSearch" v-bind="instantSearchAttr">' +
          '<ais-configure ' +
            ':hits-per-page.camel="perPage" ' +
            'v-bind="queryParameters" ' +
          '/>' +
          '<ais-hits :class-names="{\'ais-Hits\': \'ais-results\'}" :transform-items="transformItems">' +
            '<template slot-scope="{ items }">' +
              '<slot name="beforeItems" :items="items"></slot>' +
              '<slot name="itemsWrapper" :items="items">' +
                '<div class="row">' +
                  '<div class="col-md-4 mb-4" v-for="item in items" :key="item.objectID">' +
                    '<slot name="item" :item="item"></slot>' +
                  '</div>' +
                '</div>' +
              '</slot>' +
              '<slot name="afterItems" :items="items"></slot>' +
              '<div class="mt-3 d-flex flex-column align-items-center">' +
                '<slot name="beforePagination" :items="items"></slot>' +
                '<ais-pagination ' +
                  'v-if="showPagination(items.length)" ' +
                  ':class-names="{\'ais-Pagination\': \'mx-auto mt-1\', \'ais-Pagination-list\': \'pagination mb-0\'}"' +
                '></ais-pagination>' +
              '</div>' +
            '</template>' +
          '</ais-hits>' +
        '</ais-instant-search>' +
      '</div>',
    props: {
      index: { type: String, required: true },
      queryParameters: { type: Object, default: function () { return {}; } },
      perPage: { type: Number, default: 12 },
      pagination: { type: Boolean, default: true },
      transformItems: {
        type: Function,
        default: function (items) { return items; }
      }
    },
    computed: {
      ready: function () {
        return !!this.$root.algoliaReady;
      },
      instantSearchAttr: function () {
        return {
          searchClient: this.$root.algolia.searchClient,
          indexName: this.index,
          routing: this.$root.algolia.routing,
          classNames: { "ais-InstantSearch": "ais-index" }
        };
      },
      showPagination: function () {
        var self = this;
        return function (itemsTotal) {
          return !!self.pagination && Math.ceil(itemsTotal / self.perPage) > 1;
        };
      }
    }
  };

  // ---------------------------------------------------------------------------
  // 6. ItemsGrid (from ItemsGrid.vue, WITHOUT SlickCarousel)
  // ---------------------------------------------------------------------------
  var ItemsGrid = {
    name: "ItemsGrid",
    components: { SearchGrid: SearchGrid },
    props: {
      index: { type: String, required: true },
      queryParameters: { type: Object, default: function () { return {}; } },
      itemKey: { type: String },
      columns: { type: Number, default: 3 },
      filters: Array,
      transformItems: Function,
      searchQuery: Object,
      typoTolerance: { type: Boolean, default: true },
      perPage: [Number, String],
      pagination: { type: Boolean, default: true },
      archiveLink: String,
      archiveLinkText: { type: String, default: "Se alla" },
      archiveLinkPosition: {
        type: String,
        default: "top",
        validator: function (v) {
          return ["both", "top", "bottom", ""].indexOf(v) !== -1;
        }
      },
      slider: {
        type: String,
        default: "always",
        validator: function (v) {
          return ["always", "mobile-only", ""].indexOf(v) !== -1;
        }
      }
    },
    computed: {
      ready: function () {
        return !!this.index && !!this.$root.algoliaReady;
      },
      showArchiveLink: function () {
        return !!this.archiveLink && !!this.archiveLinkText;
      },
      searchGridAttr: function () {
        return {
          index: this.index,
          queryParameters: this.finalQueryParameters(),
          perPage: Number(this.perPage || 12),
          pagination: this.pagination,
          transformItems: this.transformItems
        };
      },
      itemClass: function () {
        var col = 12 / (this.columns || 3);
        return "col-md-" + col + (this.slider ? " slider-item" : "");
      }
    },
    methods: {
      finalQueryParameters: function () {
        var qp = this.queryParameters || {};
        var q = this.searchQuery || {};
        var attributes = Array.isArray(q.attributes)
          ? q.attributes
          : (q.attributes ? [q.attributes] : undefined);

        return Object.assign({}, qp, {
          distinct: true,
          typoTolerance: this.typoTolerance,
          filters: this.parseFilters(qp.filters || ""),
          query: q.query || "",
          restrictSearchableAttributes: attributes,
          facets: attributes
        });
      },
      parseFilters: function (concat) {
        if (!(this.filters || []).length) {
          return concat || undefined;
        }

        var filters = (this.filters || [])
          .map(function (f) {
            if (!f.attribute) return null;
            var op = (f.operator || "OR").toUpperCase();
            if (["OR", "AND", "NOT"].indexOf(op) === -1) op = "OR";
            f.operator = op;
            f.handle = f.attribute + ':"' + f.value + '"';
            return f;
          })
          .filter(function (f) { return !!f; });

        var ors = filters.filter(function (f) { return f.operator === "OR"; });
        var filterAndArray = []
          .concat(ors.length ? ["(" + ors.map(function (o) { return o.handle; }).join(" OR ") + ")"] : [])
          .concat(filters.filter(function (f) { return f.operator === "AND"; }).map(function (o) { return o.handle; }))
          .concat(filters.filter(function (f) { return f.operator === "NOT"; }).map(function (o) { return "NOT " + o.handle; }))
          .concat(concat || "");

        var filterString = filterAndArray.filter(function (f) { return !!f; }).join(" AND ");
        return filterString || undefined;
      }
    },
    template:
      '<search-grid ' +
        'v-if="ready" ' +
        'ref="searchGrid" ' +
        'v-bind="searchGridAttr"' +
      '>' +
        '<template #beforeItems="{ items }">' +
          '<div class="d-md-flex flex-wrap align-items-center justify-content-between mb-4">' +
            '<slot name="beforeItems" :items="items"></slot>' +
            '<a :href="archiveLink" class="button button-blue button-secondary mt-2 md:mt-0"><span class="mr-2">{{ archiveLinkText }}</span><svg class="h-4 ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"></path></svg></a>' +
          '</div>' +
        '</template>' +
        '<template #itemsWrapper="{ items }">' +
          '<slot name="itemsWrapper" :items="items">' +
            '<div ' +
              ':id="(!!slider ? `slider-${_uid}` : null)" ' +
              'class="row" ' +
              ':class="[(itemKey ? `${itemKey}--items` : null),{slider}]"' +
            '>' +
              '<div ' +
                'v-for="item in items" ' +
                ':key="item.objectID" ' +
                ':class="[(itemKey ? `${itemKey}--item` : null), itemClass]"' +
              '>' +
                '<slot name="item" :item="item" :items="items"></slot>' +
              '</div>' +
            '</div>' +
          '</slot>' +
        '</template>' +
        '<template #afterItems="{ items }">' +
          '<slot name="afterItems" :items="items"></slot>' +
        '</template>' +
        '<template #beforePagination="{ items }">' +
          '<div class="mb-1" v-if="!!items.length && !!showArchiveLink && [\'bottom\',\'both\'].includes(archiveLinkPosition)">' +
            '<a :href="archiveLink" class="button button-blue button-secondary mt-2 md:mt-0"><span class="mr-2">{{ archiveLinkText }}</span><svg class="h-4 ml-2" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M305 239c9.4 9.4 9.4 24.6 0 33.9L113 465c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l175-175L79 81c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0L305 239z"></path></svg></a>' +
          '</div>' +
        '</template>' +
      '</search-grid>'
  };

  // ---------------------------------------------------------------------------
  // 7. BookSingleCardDigitalPrint
  // ---------------------------------------------------------------------------
  var BookSingleCardDigitalPrint = {
    name: "BookSingleCardDigitalPrint",
    props: {
      book: Object,
      showPrice: { type: Boolean, default: true },
      showAuthors: { type: Boolean, default: true },
      showSubjectAreas: { type: Boolean, default: true },
      imageSize: { type: String, default: "md" },
      // false: only print | true: both | 'digital': only digital
      digitalVariant: { type: [String, Boolean], default: false }
    },
    data: function () {
      return {
        cardSize: "small",
        bookDigitalVariant: null
      };
    },
    mounted: function () {
      setTimeout(this.setCardSize, 500);
      window.addEventListener("resize", this.setCardSize);
      this.searchDigitalVariant();
    },
    beforeDestroy: function () {
      window.removeEventListener("resize", this.setCardSize);
    },
    computed: {
      hasDigitalVariant: function () {
        return !!this.digitalVariant && !!(this.bookDigitalVariant && this.bookDigitalVariant.objectID);
      },
      isDigital: function () {
        return this.book && this.book.type === "digital";
      },
      isPrint: function () {
        return this.book && this.book.type === "print";
      },
      cardIsSmall: function () {
        return this.cardSize === "small";
      },
      forcedImageSize: function () {
        if (this.imageSize === "sm") return "small";
        if (this.imageSize === "md") return "normal";
        return this.cardSize;
      }
    },
    methods: {
      setCardSize: function () {
        if (!this.$refs.card) return;
        this.cardSize = this.$refs.card.clientWidth < 680 ? "small" : "normal";
      },
      searchDigitalVariant: async function () {
        if (!this.digitalVariant || !this.book || !this.book.verkid) return;
        var index = this.$root.algolia.searchClient.initIndex("shopify_products");
        var res = await index.search("", {
          filters: "NOT primary:true AND verkid:" + this.book.verkid
        });
        this.bookDigitalVariant = res.nbHits ? res.hits[0] : null;
      },
      createLink: function (book) {
        return "https://shop.nj.se/products/" + (book && book.handle);
      },
      formatPrice: function (price) {
        try {
          return new Intl.NumberFormat("sv-SE", {
            style: "currency",
            currency: "SEK"
          }).format(price || 0);
        } catch (e) {
          return price || "";
        }
      }
    },
    template:
      '<div class="h-100">' +
        '<div v-if="isDigital" ' +
             'ref="card" ' +
             'class="book__card justify-content-center flex-wrap" ' +
             ':class="[`card-size-${cardSize}`,{ \'has-digital-variant\' : hasDigitalVariant }]"' +
        '>' +
          '<div class="d-flex justify-content-center align-items-start flex-column w-100" ' +
               ':class="{\'flex-column text-center h-100\' : cardIsSmall }">' +
            '<div class="book__card_tags mb-2" v-if="cardIsSmall && showSubjectAreas">' +
              '<ul class="text-center">' +
                '<li v-for="(itm, index) in book.subject_areas" :key="\'tag_\'+index">' +
                  '<span v-html="itm" class="active post-card--tag-link"></span>' +
                '</li>' +
              '</ul>' +
            '</div>' +
            '<div class="book__card-cntr_image mb-3">' +
              '<a :href="createLink(book)" class="text-decoration-none">' +
                '<img :class="\'size-\'+forcedImageSize" :src="book.image"/>' +
              '</a>' +
            '</div>' +
            '<div class="book__card-cntr_body" :class="{ \'px-4 mt-auto\' : cardIsSmall }">' +
              '<div class="book__card_tags" v-if="!cardIsSmall && showSubjectAreas">' +
              '<ul class="d-flex justify-content-center align-items-center flex-wrap">' +
                  '<li v-for="(itm, index) in book.subject_areas" :key="\'tag2_\'+index">' +
                    '<span v-html="itm" class="active post-card--tag-link"></span>' +
                  '</li>' +
                '</ul>' +
              '</div>' +
              '<a :href="createLink(book)" class="text-decoration-none color-inherit">' +
                '<h4>{{ book.title }}</h4>' +
              '</a>' +
              '<div class="book__card_vendor" v-if="showAuthors">' +
                '<ul>' +
                  '<li v-for="(itm, index) in book.vendor" :key="\'vendor_\'+index">' +
                    '<span v-html="itm"></span>' +
                  '</li>' +
                '</ul>' +
              '</div>' +
              '<div class="buttons_cntr d-flex flex-column w-100 flex-wrap my-2" ' +
                   ':class="(cardIsSmall ? \'\' : \'flex-md-row\' )">' +
                '<a ' +
                  ':href="createLink(hasDigitalVariant ? bookDigitalVariant : book)" ' +
                  'target="_blank" ' +
                  'class="digital-variant-button book__card_button d-flex align-items-center justify-content-center" ' +
                  ':class="[\'size-\'+cardSize,(digitalVariant != \'digital\' ? \'mt-1\' : \'\')]"' +
                '>' +
                  
                  '<span>Digitalt i JUNO</span>' +
                '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +

        '<div v-if="!isDigital" ' +
             'ref="card" ' +
             'class="book__card d-flex justify-content-center" ' +
             ':class="[`card-size-${cardSize}`]"' +
        '>' +
          '<div class="d-flex justify-content-center align-items-center flex-column w-100" ' +
               ':class="{\'flex-column text-center h-100\' : cardIsSmall }">' +
            '<div class="book__card_tags mb-2" v-if="cardIsSmall && showSubjectAreas">' +
              '<ul class="d-flex justify-content-center align-items-center flex-wrap">' +
                '<li v-for="(itm, index) in book.subject_areas" :key="\'tag3_\'+index">' +
                  '<span v-html="itm" class="active post-card--tag-link"></span>' +
                '</li>' +
              '</ul>' +
            '</div>' +
            '<div class="book__card-cntr_image mb-3">' +
              '<a :href="createLink(book)" class="text-decoration-none">' +
                '<img :class="\'size-\'+forcedImageSize" :src="book.image"/>' +
              '</a>' +
            '</div>' +
            '<div class="book__card-cntr_body" :class="{ \'px-4 mt-auto\' : cardIsSmall }">' +
              '<div class="book__card_tags" v-if="!cardIsSmall && showSubjectAreas">' +
                '<ul>' +
                  '<li v-for="(itm, index) in book.subject_areas" :key="\'tag4_\'+index">' +
                    '<span v-html="itm" class="active post-card--tag-link"></span>' +
                  '</li>' +
                '</ul>' +
              '</div>' +
              '<a :href="createLink(book)" class="text-decoration-none color-inherit">' +
                '<h4>{{ book.title }}</h4>' +
              '</a>' +
              '<div class="book__card_vendor" v-if="showAuthors">' +
                '<ul>' +
                  '<li v-for="(itm, index) in book.vendor" :key="\'vendor2_\'+index">' +
                    '<span v-html="itm"></span>' +
                  '</li>' +
                '</ul>' +
              '</div>' +
              '<div class="buttons_cntr d-flex flex-column w-100 flex-wrap my-2" ' +
                   ':class="(cardIsSmall ? \'\' : \'flex-md-row\' )">' +
                '<a v-if="(digitalVariant != \'digital\' && !isDigital)" ' +
                   ':href="createLink(book)" ' +
                   'class="btn btn-primary book__card_button" ' +
                   ':class="\'size-\'+cardSize">' +
                  '<svg style="height: 1rem; width: 1rem; display: inline-block; margin-right: .5rem;" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M16 0C7.2 0 0 7.2 0 16s7.2 16 16 16l37.9 0c7.6 0 14.2 5.3 15.7 12.8l58.9 288c6.1 29.8 32.3 51.2 62.7 51.2L496 384c8.8 0 16-7.2 16-16s-7.2-16-16-16l-304.8 0c-15.2 0-28.3-10.7-31.4-25.6L152 288l314.6 0c29.4 0 55-20 62.1-48.5L570.6 71.8c5-20.2-10.2-39.8-31-39.8L99.1 32C92.5 13 74.4 0 53.9 0L16 0zm90.1 64l433.4 0L497.6 231.8C494 246 481.2 256 466.5 256l-321.1 0L106.1 64zM168 456a24 24 0 1 1 48 0 24 24 0 1 1 -48 0zm80 0a56 56 0 1 0 -112 0 56 56 0 1 0 112 0zm200-24a24 24 0 1 1 0 48 24 24 0 1 1 0-48zm0 80a56 56 0 1 0 0-112 56 56 0 1 0 0 112z"></path></svg>' +
                  '<span v-html="(showPrice ? formatPrice(book.price) : \'Köp\')"></span>' +
                '</a>' +
              '</div>' +
            '</div>' +
          '</div>' +
        '</div>' +
      '</div>'
  };

  // ---------------------------------------------------------------------------
  // 8. BooksByAttribute (outer component that uses ItemsGrid + card)
  // ---------------------------------------------------------------------------
  var BooksByAttribute = {
    name: "BooksByAttribute",
    components: {
      ItemsGrid: ItemsGrid,
      BookSingleCardDigitalPrint: BookSingleCardDigitalPrint
    },
    props: {
      index: String,
      filters: Array,
      searchQuery: Object,
      typoTolerance: Boolean,
      perPage: [Number, String],
      pagination: Boolean,
      filterOut: Object,
      archiveLink: String,
      archiveLinkText: { type: String, default: "Se alla publikationer" },
      archiveLinkPosition: String,
      slider: String,
      columns: { type: Number, default: 3 },
      showHeading: { type: Boolean, default: false },
      headlineMobile: String,
      headlineDesktop: String,
      showPrice: { type: Boolean, default: true },
      showAuthors: { type: Boolean, default: true },
      showSubjectAreas: { type: Boolean, default: true },
      imageSize: { type: String, default: "md" },
      digitalVariant: { type: [String, Boolean], default: false }
    },
    computed: {
      itemGridAttr: function () {
        return {
          itemKey: "books-listing",
          index: this.index || DEFAULT_INDEX_NAME,
          filters: this.parseFilters(),
          searchQuery: this.searchQuery,
          typoTolerance: this.typoTolerance,
          perPage: this.perPage,
          pagination: !!this.pagination,
          queryParameters: {
            attributesToRetrieve: ["*"]
          },
          archiveLink: this.archiveLink || "https://www.nj.se/litteratur",
          archiveLinkText: this.archiveLinkText,
          archiveLinkPosition: this.archiveLinkPosition,
          slider: this.slider,
          columns: this.columns
        };
      },
      singleCardAttr: function () {
        return {
          showPrice: this.showPrice,
          showAuthors: this.showAuthors,
          showSubjectAreas: this.showSubjectAreas,
          digitalVariant: this.digitalVariant,
          imageSize: this.imageSize
        };
      },
      computedHeadline: function () {
        if (!this.showHeading) return;
        var defaultHeading = "Relaterade publikationer";
        var desktopHeading = this.headlineDesktop || defaultHeading;
        var desktopMobile = this.headlineMobile || defaultHeading;

        var clientWidth =
          document.documentElement.clientWidth ||
          window.innerWidth ||
          document.body.clientWidth;

        return clientWidth < 768 ? desktopMobile : desktopHeading;
      }
    },
    methods: {
      parseFilters: function () {
        var filters = [];
        (this.filters || []).forEach(function (f) {
          var value = null;
          switch (f.search_by) {
            case "subjects":
              value = (f.subject && f.subject.columns || {}).name;
              break;
            case "subjectAreas":
              f.search_by = "subject_areas";
              value =
                (f.subject_area && f.subject_area.columns || {}).name ||
                f.subject_area;
              break;
            default:
              value = f.attribute_value;
              break;
          }
          filters.push({
            attribute: f.search_by,
            value: value,
            operator: f.operator || "AND"
          });
        });

        var filterOut = this.filterOut || {};
        if (typeof filterOut === "object" && !Array.isArray(filterOut)) {
          Object.entries(filterOut || {}).forEach(function (_ref) {
            var attribute = _ref[0];
            var values = _ref[1];
            values = Array.isArray(values) ? values : [values];
            values.forEach(function (value) {
              filters.push({ attribute: attribute, value: value, operator: "NOT" });
            });
          });
        }
        return filters;
      }
    },
    template:
      '<items-grid class="books-by-attribute" v-bind="itemGridAttr">' +
        '<template #beforeItems="{ items }">' +
          '<h2 v-if="items.length && computedHeadline" class="mr-auto" v-html="computedHeadline"></h2>' +
        '</template>' +
        '<template #item="{ item, items }">' +
          '<book-single-card-digital-print ' +
            ':key="item.objectID" ' +
            ':class="{\'mb-4\' : items.length > 1}" ' +
            ':book="item" ' +
            'v-bind="singleCardAttr" ' +
          '/>' +
        '</template>' +
      '</items-grid>'
  };

  // ---------------------------------------------------------------------------
  // 9. ExpertSingleCard
  // ---------------------------------------------------------------------------
  var ExpertSingleCard = {
    name: "ExpertSingleCard",
    props: ["expert", "reversed"],
    computed: {
      expertUrl: function () {
        return "https://www.nj.se/experter/" + this.expert.slug;
      }
    },
    template:
      '<div>' +
        '<a :href="expertUrl" class="text-decoration-none">' +

          '<div class="expert-single-card d-md-flex flex-wrap mb-4" ' +
               ':class="{\'flex-md-row-reverse\' : reversed, \'flex-md-row\': !reversed}">' +

            '<div class="col-md-3">' +
              '<div class="expert-single-photo">' + 
                '<img :src="expert.photo" />' +
              '</div>' + 
            '</div>' + 

            '<div class="col-md-9 expert-single-info" >' +
              '<h4>' +
                '<span v-html="expert.firstname"></span> ' +
                '<span v-html="expert.lastname"></span>' +
              '</h4>' +
              '<div v-if="expert.title" style="font-weight:bold;margin-top:1rem;" v-html="expert.title"></div>' +
              '<div v-if="expert.description" style="margin-top:1rem;" v-html="expert.description"></div>' +
            '</div>' +

        '</a>' +
      '</div>'
  };

  // ---------------------------------------------------------------------------
  // 10. ExpertsByIds
  // ---------------------------------------------------------------------------
  var ExpertsByIds = {
    name: "ExpertsByIds",
    components: {
      SearchWrapper: SearchWrapper,
      ExpertSingleCard: ExpertSingleCard
    },
    props: ["ids", "index", "headline"],
    computed: {
      idsArray: function () {
        if (Array.isArray(this.ids)) return this.ids;
        if (!this.ids) return [];
        return this.ids.split(",").map(function (s) { return s.trim(); }).filter(Boolean);
      },
      query_parameters: function () {
        var ids = this.idsArray;
        var filters = "";
        ids.forEach(function (id, index) {
          filters += (index !== 0 ? " OR " : "") + 'objectID:"' + id.toString().trim() + '"';
        });
        return {
          distinct: true,
          typoTolerance: false,
          restrictSearchableAttributes: "objectID",
          filters: filters
        };
      },
      indexName: function () {
        return this.index ? this.index : "experts";
      },
      linkToAll: function () {
        return "https://www.nj.se/experts";
      }
    },
    methods: {
      orderItems: function (items) {
        var ids = this.idsArray;
        var newItems = [];
        items.forEach(function (item) {
          var idx = ids.indexOf(item.objectID);
          if (idx !== -1) newItems[idx] = item;
        });
        return newItems.filter(function (item) { return !!item; });
      }
    },
    template:
      '<div class="container--experts-by-ids">' +
        '<search-wrapper ' +
          'v-slot:default="{ items }" ' +
          ':query-parameters="query_parameters" ' +
          ':index="indexName" ' +
          ':pagination="false"' +
        '>' +
          '<h2 class="mb-4 text-center" v-if="headline && items.length" v-html="headline"></h2>' +
          '<div class="mb-4" v-for="(result, index) in orderItems(items)" :key="result.objectID">' +
            '<expert-single-card :expert="result" :reversed="index%2!==0"></expert-single-card>' +
          '</div>' +
        '</search-wrapper>' +
      '</div>'
  };

  // ---------------------------------------------------------------------------
  // 11. Global registration
  // ---------------------------------------------------------------------------
  Vue.component("search-wrapper", SearchWrapper);
  Vue.component("shopify-book-type", ShopifyBookType);
  Vue.component("search-grid", SearchGrid);
  Vue.component("items-grid", ItemsGrid);
  Vue.component("book-single-card-digital-print", BookSingleCardDigitalPrint);
  Vue.component("books-by-attribute", BooksByAttribute);
  Vue.component("expert-single-card", ExpertSingleCard);
  Vue.component("experts-by-ids", ExpertsByIds);

  // ---------------------------------------------------------------------------
  // 12. Root helpers & per-element mounting
  // ---------------------------------------------------------------------------
  function createRoot(el, renderComponent, props) {
    return new Vue({
      el: el,
      data: function () {
        return {
          algoliaReady: true,
          algolia: {
            searchClient: searchClient,
            routing: undefined
          }
        };
      },
      render: function (h) {
        return h(renderComponent, { props: props || {} });
      }
    });
  }

  function initShopifyBookTypes() {
    var nodes = document.querySelectorAll("shopify-book-type");
    Array.prototype.forEach.call(nodes, function (el) {
      var props = {
        headline: el.getAttribute("headline") || "",
        primary: el.getAttribute("primary"),
        product_type: el.getAttribute("product_type"),
        verkid: el.getAttribute("verkid"),
        algo_index: el.getAttribute("algo_index") || DEFAULT_INDEX_NAME,
        dev_env: boolAttr(el, "dev_env", false)
      };
      createRoot(el, ShopifyBookType, props);
    });
  }

  function initBooksByAttribute() {
    var nodes = document.querySelectorAll("books-by-attribute");
    Array.prototype.forEach.call(nodes, function (el) {
      // from markup: :search-query="{ query: ['id1','id2'], attributes: ['product_id'] }"
      var searchQueryStr =
        el.getAttribute(":search-query") ||
        el.getAttribute("search-query");
      var searchQuery = parseSearchQueryAttr(searchQueryStr);

      var props = {
        index: el.getAttribute("index") || DEFAULT_INDEX_NAME,

        // from markup: :pagination="false"
        pagination: boolAttr(el, "pagination", true),

        // from markup: :show-heading="true"
        showHeading: boolAttr(el, "show-heading", false),

        searchQuery: searchQuery,

        columns: numAttr(el, "columns", 3),
        headlineMobile: el.getAttribute("headline-mobile") || "",
        headlineDesktop: el.getAttribute("headline-desktop") || "",
        showPrice: boolAttr(el, "show-price", true),
        showAuthors: boolAttr(el, "show-authors", true),
        showSubjectAreas: boolAttr(el, "show-subject-areas", true),
        imageSize: el.getAttribute("image-size") || "md",
        digitalVariant: el.getAttribute("digital-variant") || false,

        archiveLink: el.getAttribute("archive-link") || "",
        archiveLinkText:
          el.getAttribute("archive-link-text") || "Se alla publikationer",
        archiveLinkPosition:
          el.getAttribute("archive-link-position") || "top"
      };

      createRoot(el, BooksByAttribute, props);
    });
  }

  function initExpertsByIds() {
    var nodes = document.querySelectorAll("experts-by-ids");
    Array.prototype.forEach.call(nodes, function (el) {
      var props = {
        headline: el.getAttribute("headline") || "",
        index: el.getAttribute("index") || "experts",
        ids: el.getAttribute("ids") || ""
      };
      createRoot(el, ExpertsByIds, props);
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initShopifyBookTypes();
      initBooksByAttribute();
      initExpertsByIds();
    });
  } else {
    initShopifyBookTypes();
    initBooksByAttribute();
    initExpertsByIds();
  }
})();
